import React, { Fragment, ReactElement } from 'react';
import Style from './LoadingIndicator.module.scss'
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { SystemState } from '../../store/system/types';

interface LoadingIndicatorProps{
    system: SystemState,
    children: ReactElement
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props: LoadingIndicatorProps) => {
    return props.system.showLoading ? (
        <div className={Style.loadingIndicator}>
            {props.children}
        </div>)
        :
        (<Fragment></Fragment>);
};

const mapStateToProps = (state: AppState) => ({
    system: state.system
});

export default connect(mapStateToProps)(LoadingIndicator);
